import { sharedRedeliveryTermHeading } from './sharedRedeliveryTermHeading';

export const orderRedeliveryTermHeading = {
    ...sharedRedeliveryTermHeading,
    hide: true,
};
